import React from 'react';
import PropTypes from 'prop-types';

import { getDateTime } from 'utils';
import { UiIcon } from 'ui-components';

import { StyledNotificationContainer } from './NotifyAll.styles';

const NotifyAll = (props) => {
  const { title, description, time: dateTime, isRead } = props;
  const { date, time } = getDateTime(dateTime);

  return (
    <StyledNotificationContainer isRead={isRead}>
      <div className='notification-header'>
        <div className='flex gap-10'>
          {!isRead && <span className='bullet'></span>}

          <UiIcon icon='ri-notification-3-fill' />

          <span className='title'>{title}</span>
        </div>

        <bdi className='date-time'>
          <span className='mr-5'>{date}</span>
          {time}
        </bdi>
      </div>

      <p className='description'>{description}</p>
    </StyledNotificationContainer>
  );
};

NotifyAll.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  time: PropTypes.string,
  isRead: PropTypes.number,
};

export default NotifyAll;
